import React from 'react'; 
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types'


export default class CardsDynamic extends React.Component{
        // necesita :
    // props.elemente as JSON
    // props.onElementClick ca functie de callback cand da click pe o linie
    

    // props.onlyColumns: obiect care defineste title,subhead si content

    // specific dictionar:
    // daca props.keysDictionary is not null se va face o traducere a capului de tabel
    // pe sistemul daca gaseste cheia in this props elemente si ea exista tot ca si cheie in  keysDictionary

    constructor(props){
        super(props);
    }

    state = {
        elementeAfisate: this.props.elemente || [],
        searchString: ''
    } 

    componentDidMount(){

    }



    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{
        return (tx || 'LI').substring(0,2).toUpperCase()
    }

    filterFunc = (ev) => {

        this.setState({searchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.title]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.subhead]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true

            return false

        })

        this.setState({elementeAfisate: e})
    }

    
    callbackfunc = (el)=> {
        this.props.onElementClick(el);
    }

    render(){
        return (
            <div>

                <TextField className='inputFocus' label={this.props.dictionary.comune.search} onChange={this.filterFunc} value={this.state.searchString} />

                <Grid className='pm-cards-container' container spacing={8}>
              
                {
                    this.state.elementeAfisate.map( (e,nidx)=>{
                        return (
                            <Grid className='pm-cards-item' item sm={12} xs={12} md={4} key={nidx} onClick={() => { this.callbackfunc(e) }}>
                                <Card className="pm-cards-card">

                                    <CardHeader
                                        avatar = { <Avatar className='pm-avatar'> { this.getLitereAvatar(e[this.props.onlyColumns.title]) } </Avatar> } 
                                        title={ <span className="pm-cards-title">{e[this.props.onlyColumns.title]}</span>}
                                        subheader={ e[this.props.onlyColumns.subhead1] }
                                    >
                                        
                                    </CardHeader>

                                    <CardContent className="pm-cards-content">
                                        { e[this.props.onlyColumns.content]}
                                    </CardContent>

                                    <CardActions style={{display:'block', textAlign:'right'}}>
                                        <IconButton className='pm-cards-button' aria-label="Add to favorites">
                                          <span > { this.props.dictionary.comune.detailsView }</span> 
                                            <i className="material-icons "> chevron_right </i>
                                        </IconButton>
                                    </CardActions>

                                </Card>
                            </Grid>
                        )
                    }) 
                }
                
                </Grid>

            </div>
        );
    }


}  // end class

CardsDynamic.propType = {
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dictionary:PropTypes.object,

}
